import * as Shape from './shape';

export * from '@antv/g-base';
export { IElement, IGroup, IShape } from './interfaces';
export { default as Canvas } from './canvas';
export { default as Group } from './group';
export { Shape };

export const version = '0.5.6';
